/* eslint-disable new-cap */
import Phaser from 'phaser';
import gameData from '../gameData';

export default class QuestionGenerator {
  constructor(gametype, gamelevel) {
    this.gameType = gametype;
    this.gameLevel = gamelevel;
    this.min;
    this.max;
    this.negativeMod = 0;

    switch (this.gameLevel) {
      case gameData.GAMELEVEL_EASY:
        this.min = 1;
        this.max = 100;
        this.negativeMod = 0;
        break;
      case gameData.GAMELEVEL_MEDIUM:
        this.min = 1;
        this.max = 100;
        this.negativeMod = 0;
        break;
      case gameData.GAMELEVEL_HARD:
        this.min = 1;
        this.max = 2000;
        this.negativeMod = 1000;
        break;
    }
  }

  getNewNumberSet = function () {
    let question = [];
    const num1 = { type: null, value: 0 };
    const num2 = { type: null, value: 0 };

    num1.type = this.gameType;
    num2.type = this.gameType;
    switch (this.gameType) {
      case gameData.GAMETYPE_WHOLE_NUMBERS:
        num1.value = this.generateWholeNumber();
        num2.value = this.generateWholeNumber();
        break;

      case gameData.GAMETYPE_DECIMALS:
        num1.value = this.generateDecimal();
        num2.value = this.generateDecimal();
        break;

      case gameData.GAMETYPE_FRACTIONS:
        num1.value = this.generateFraction();
        num2.value = this.generateFraction();
        break;

      case gameData.GAMETYPE_MIXED:
        const types = [0, 1, 2];
        const roll = Phaser.Math.Between(0, types.length - 1);
        num1.type = types[roll];
        if (types[roll] === gameData.GAMETYPE_WHOLE_NUMBERS) {
          num1.value = this.generateMixedWholeNumber();
        }
        else if (types[roll] === gameData.GAMETYPE_DECIMALS) {
          num1.value = this.generateDecimal();
        }
        else if (types[roll] === gameData.GAMETYPE_FRACTIONS) {
          num1.value = this.generateFraction();
        }

        // !!if we want them to be different  types.splice(types.indexOf(roll),1);
        const roll2 = Phaser.Math.Between(0, types.length - 1);
        num2.type = types[roll2];
        if (types[roll2] === gameData.GAMETYPE_WHOLE_NUMBERS) {
          num2.value = this.generateMixedWholeNumber();
        }
        else if (types[roll2] === gameData.GAMETYPE_DECIMALS) {
          num2.value = this.generateDecimal();
        }
        else if (types[roll2] === gameData.GAMETYPE_FRACTIONS) {
          num2.value = this.generateFraction();
        }
        break;
    }
    question = [num1, num2];
    return question;
  };

  generateWholeNumber = function () {
    return Phaser.Math.Between(this.min, this.max) - this.negativeMod;
  };

  generateMixedWholeNumber = function () {
    return Phaser.Math.Between(1, 4);
  };

  generateDecimal = function () {
    return Phaser.Math.Between(1, 99) / 100;
  };

  generateFraction = function () {
    const d = Phaser.Math.Between(2, 12);
    let n;
    if (d === 2) {
      n = 1;
    }
    else {
      n = Phaser.Math.Between(1, d - 1);
    }
    const fraction = {};// new Fraction(n,d);
    fraction.numerator = n;
    fraction.denominator = d;
    fraction.decimalValue = n / d;
    return fraction;
  };
}